import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DetalleCarga from "./components/TablaDetalleCarga";
import { parseCargaData } from "./utils/parseCargaDataUp";
import { sendGroupToAPI } from "./utils/sendGroupToAPI";
import { sleep } from "./utils/sleep";
import { API_ENDPOINTS } from "../../api/endpoints";
import { IconClockCog } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const CreateProgramado = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [results, setResults] = useState([]);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
  const navigate = useNavigate();

  const handleVolver = () => {
    navigate(-1); // Regresa a la página anterior en el historial
  };

  useEffect(() => {
    if (!id) {
      setError("ID no válido.");
      setLoading(false);
      return;
    }

    const apiCreateServicesGhostAPI = API_ENDPOINTS.interna.CreateServicesGhostAPI(id);

    fetch(apiCreateServicesGhostAPI)
      .then((res) => {
        if (!res.ok) throw new Error("Error al obtener los datos de la API");
        return res.json();
      })
      .then((rawData) => {
        const parsed = parseCargaData(rawData);
        setData(parsed);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Error al cargar los datos");
        setLoading(false);
      });
  }, [id]);

  const processGroup = async (group) => {
    if (!group.destination?.address?.coordinate?.latitude || !group.destination.address.coordinate.longitude) {
      return {
        groupName: group.name,
        error: "Coordenadas de destino inválidas",
        status: "error",
      };
    }

    try {
      const bookingId = await sendGroupToAPI(group);
      return { groupName: group.name, bookingId, status: "success" };
    } catch (err) {
      return { groupName: group.name, error: err.message, status: "error" };
    }
  };

  const processGroups = async () => {
    if (!data || !data.groups) return;

    const bookingResults = [];
    const groupsInChunks = [];

    while (data.groups.length) {
      groupsInChunks.push(data.groups.splice(0, 3));
    }

    setProgress({ current: 0, total: groupsInChunks.length });

    for (const chunk of groupsInChunks) {
      const chunkResults = await Promise.all(chunk.map(processGroup));
      bookingResults.push(...chunkResults);
      setProgress((prev) => ({ ...prev, current: prev.current + 1 }));
      await sleep(2000);
    }

    setResults(bookingResults);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <h1>
          Cargando
          <p>
            <svg id="page-preload" viewBox="25 25 50 50">
              <circle r="20" cy="50" cx="50"></circle>
            </svg>
          </p>
        </h1>
      </div>
    );
  }
  if (error) return <div>{error}</div>;

  return (
    <div className="container-fluid">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="page-pretitle">
                Crear Servicios <span className="badge bg-blue text-blue-fg">SUBIDA</span>
              </div>
              <h2 className="page-title">Datos Servicios</h2>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                <button className="btn btn-pill" onClick={handleVolver}>
                  Volver
                </button>
                <button className="btn btn-success btn-pill" onClick={processGroups} disabled={progress.current > 0 && progress.current < progress.total}>
                  {progress.current > 0 && progress.current < progress.total ? "Procesando..." : "Crear Servicios en Autocab"}
                </button>
              </div>
            </div>

            {progress.total > 0 && progress.current < progress.total && (
              <div
                className="card"
                style={{
                  position: "fixed",
                  top: "30%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 1050,
                  width: "90%",
                  maxWidth: "400px",
                  border: "2px solid rgba(214, 57, 57, 0.3)",
                }}
              >
                <div className="card-stamp">
                  <div className="card-stamp-icon bg-red">
                    <IconClockCog size={52} />
                  </div>
                </div>
                <div className="card-body">
                  <h3 className="card-title">Creando servicios, espere...</h3>
                  <p style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                    Procesando {progress.current} de {progress.total} bloques...
                  </p>
                </div>
              </div>
            )}

            {results.length > 0 && (
              <div className="mt-4">
                <h3>📋 Resultados del Envío</h3>
                <div className="row">
                  {results.map((result, index) => (
                    <div className="col-md-6 col-lg-4 mb-3" key={index}>
                      <div className={`card border-${result.status === "success" ? "green" : "red"}`}>
                        <div className={`card-status bg-${result.status === "success" ? "green" : "red"}`}></div>
                        <div className="card-body">
                          <h4 className="card-title">{result.status === "success" ? "✅ Enviado correctamente" : "❌ Error en el envío"}</h4>
                          <p className="mb-1">
                            <strong>Grupo:</strong> {result.groupName}
                          </p>
                          {result.status === "success" ? (
                            <p className="mb-0">
                              <strong>Reserva:</strong> {result.bookingId}
                            </p>
                          ) : (
                            <p className="mb-0 text-danger">
                              <strong>Detalle:</strong> {result.error}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div>
            <DetalleCarga id={id} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProgramado;
